import React, { SVGProps } from "react"

function BigCaretLeft(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 41 230"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.175.338h15.65L17.18 115l23.647 114.662H25.175L.822 115 25.175.338z"
        fill="currentColor"
      />
    </svg>
  )
}

export default BigCaretLeft
